import { PermissionGate } from '@components/PermissionGate';
import { Switcher } from '@components/Switcher';
import { useBankProfile } from '@contexts/BankProfileContext';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Capability, Role } from 'types/roles';

import { Approvals } from './Approvals/Approvals';
import { Messages } from './Messages/Messages';

export const ApprovalsMessagesWidget = () => {
	const { t } = useTranslation('', { keyPrefix: 'dashboard' });
	const { selectedProfile } = useBankProfile();

	const canSign =
		selectedProfile?.role !== Role.CREATE && selectedProfile?.role !== Role.VIEW;

	const switchOptions = [
		{ label: t('approvals.title'), value: 'approvals' },
		{ label: t('messages.title'), value: 'messages' },
	];

	const [switcherValue, setSwitcherValue] = useState(
		canSign ? switchOptions[0].value : switchOptions[1].value,
	);

	useEffect(() => {
		if (!canSign) {
			setSwitcherValue('messages');
		}
	}, [canSign]);

	const isMessages = switcherValue === 'messages';

	return (
		<div className="bg-neutral-white p-space-24 rounded-lg flex flex-col items-center h-full">
			<PermissionGate capability={Capability.SIGN_PAYMENT}>
				<Switcher
					buttonClassName="flex-1"
					className="mb-space-16 w-max sm:w-full"
					onChange={setSwitcherValue}
					options={switchOptions}
					optionsClassName="w-full"
					value={switcherValue}
				/>
			</PermissionGate>

			{isMessages ? <Messages canSign={canSign} /> : <Approvals />}
		</div>
	);
};
